<div fxLayout="column" fxLayoutAlign="center center">
  <div fxLayout="column" class="container">
    <div fxLayout="row wrap" fxFlex="100" fxLayoutGap="10px" fxLayoutGap.lt-lg="48px" fxLayoutAlign="center center">
      <div class="courier" fxLayoutGap="32px" fxLayout="column">
        <div fxLayout="row" fxLayoutGap="32px" fxLayout.sm="column-reverse" fxLayout.xs="column-reverse" fxLayoutAlign="center center">
          <div fxFlex="60">
            <h2>ReSupply Courier: Giving Made Simple</h2>
            <p>
              You will be eligible for a
              <strong>same-day</strong>
              courier pickup only if you are donating up to 5 bags and/or boxes and are willing to bring them directly to the driver.
            </p>
          </div>
          <div fxFlex="40">
            <img class="courier-section-image" [src]="'/assets/split-screen-v4/uber_section.jpg'" />
          </div>
        </div>
        <div
          fxLayout.sm="column"
          fxLayout.xs="column"
          fxLayout="row"
          fxLayoutGap="32px"
          fxLayoutAlign="center end"
          fxLayoutAlign.sm="center start"
        >
          <div fxFlex="60" fxFlex.md="50">
            <h3>What we offer</h3>
            <ul>
              <li>
                <span>Affordable and even free</span>
                pickup options
              </li>
              <li>
                <span>A trusted driver</span>
                who picks up your items
                <span>right from your home</span>
              </li>
              <li>
                Your valuable items will be able to
                <span>support your local community</span>
              </li>
            </ul>
          </div>
          <button
            fxLayout="row"
            fxFlex.md="50"
            fxLayoutAlign="space-between center"
            fxLayoutGap="10px"
            class="primary"
            fxFlex="40"
            (click)="goToPrimary(sectionType)"
          >
            <span fxFlex="100">Check if you are eligible</span>
            <mat-icon svgIcon="ss3-arrow-right" />
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
